import React, { useState } from "react";
import * as Components from "../../../components/all";
import { useParams } from "react-router-dom";

import { AiOutlineNumber, AiOutlinePhone } from "react-icons/ai";
import {
	RiImageAddLine,
	RiMoneyDollarCircleLine,
	RiParkingBoxLine,
} from "react-icons/ri";
import {
	MdOutlineAlternateEmail,
	MdOutlinePlaylistAddCheck,
} from "react-icons/md";
import { TbClockOff, TbLocation } from "react-icons/tb";
import { FaCity } from "react-icons/fa";
import { BiMap } from "react-icons/bi";
import { BsClockHistory } from "react-icons/bs";
import { CgList } from "react-icons/cg";

export default function User() {
	const params = useParams();
	const [loading, setLoading] = useState(false);
	// Map
	const [showMap, setShowMap] = useState(false);

	// Styles
	var mainContainerStyles = `flex items-center justify-center 
    flex-wrap sm:mx-20 md:mx-24`;
	var containerStyles = `h-fit min-w-full sm:min-w-[350px] flex-1 flex items-cente p-2 text-darker overflow-x-auto border rounded-md shadow-sm m-1`;
	var iconStyles = `h-6 aspect-square flex items-center justify-center text-dark borde mr-3`;
	var inputStyles = `flex-1 bg-transparent text-sm text-darker focus:outline-none`;
	var imageStyles = `h-32 m-2 aspect-square  border rounded-md flex cursor-pointer relative overflow-hidden
    shadow-sm duration-300 ease-in-out
    hover:shadow-md`;


	// New Parking Space
	const [newPS, setNewPS] = useState({
		name: null,
		phone: null,
		email: null,
		address: null,
		latitude: null,
		longitude: null,
		city: null,
		totalSlots: null,
		shadedSlots: null,
		paidSlots: null,
		mon: false,
		tue: false,
		wed: false,
		thu: false,
		fri: false,
		sat: false,
		sun: false,
		from: null,
		to: null,
		img1: null,
		img2: null,
		img3: null,
	});

	// Handle Create
	const handleCreate = () => {
		console.log(newPS);
		for (var key in newPS) {
			if (newPS.hasOwnProperty(key) && newPS[key] === null) {
				console.log("Found null value for property:", key);
			}
		}
	};

	// Validate Image
	const validate = (e) => {
		let x = true;
		if (
			e.target.files[0]?.type !== "image/jpeg" &&
			e.target.files[0]?.type !== "image/jpg" &&
			e.target.files[0]?.type !== "image/png"
		) {
			console.log("Only jpeg, jpg and png are allowed.");
			x = false;
		}
		return x;
	};

	return loading === true ? (
		<Components.Loader />
	) : (
		<div
			className="NewParkingSpace
            overflow-x-hidden overflow-y-auto 
            h-full
            w-full
            sm:p-3 md:p-5
            flex flex-col
            "
		>
			{/* TOP CARDS ROW */}
			<div className="TOP-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap flex-1">
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="relative
					min-h-[450px]
					sm:min-w-[350px] flex-1
                    p-5 m-2
					overflow-hidden
                    rounded-md
                    bg-white 
                    flex flex-col
                    duration-150 ease-in-out
                    "
				>
					{/* Map Component*/}
					{showMap === true && (
						<div
							className="absolute
		            		bg-[#F8F9FD] 
                            top-0 left-0
                            p-2
                            h-full w-full
                            flex flex-col
                            z-20
                            "
						>
							<Components.MapCoordinates
								setNewPS={setNewPS}
								setShowMap={setShowMap}
							/>
						</div>
					)}

					{/* Heading */}
					<div
						className="
							w-full
							p-2 pt-0 
							flex 
							items-center justify-between 
							flex-wrap
							"
					>
						<div className="flex items-center">
							<Components.BackButton />
							<h1 className="ml-2 text-darker">New Parking Space Form</h1>
						</div>
					</div>

					{/* General */}
					<div className={mainContainerStyles}>
						{/* divider */}
						<div className="w-full my-5">
							<h1 className="w-fit px-4 border-b mx-auto text-darker uppercase">
								General Information
							</h1>
						</div>

						{/* name */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<RiParkingBoxLine />
							</div>
							<input
								type="text"
								className={inputStyles}
								placeholder="Name"
								value={newPS.name}
								onChange={(e) =>
									setNewPS((prev) => ({ ...prev, name: e.target.value }))
								}
							/>
						</div>

						{/* phone */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<AiOutlinePhone />
							</div>
							<input
								type="number"
								className={inputStyles}
								placeholder="Phone"
								value={newPS.phone}
								onChange={(e) =>
									setNewPS((prev) => ({ ...prev, phone: e.target.value }))
								}
							/>
						</div>

						{/* email */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<MdOutlineAlternateEmail />
							</div>
							<input
								type="email"
								className={inputStyles}
								placeholder="Email"
								value={newPS.email}
								onChange={(e) =>
									setNewPS((prev) => ({ ...prev, email: e.target.value }))
								}
							/>
						</div>
					</div>

					{/* Location */}
					<div className={mainContainerStyles}>
						{/* divider */}
						<div className="w-full my-5">
							<h1 className="w-fit px-4 border-b mx-auto text-darker uppercase">
								Location Information
							</h1>
						</div>

						{/* address */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<TbLocation />
							</div>
							<input
								type="text"
								className={inputStyles}
								placeholder="Address"
								value={newPS.address}
								onChange={(e) =>
									setNewPS((prev) => ({ ...prev, address: e.target.value }))
								}
							/>
						</div>

						{/* city */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<FaCity />
							</div>
							<input
								type="text"
								className={inputStyles}
								placeholder="City"
								value={newPS.city}
								onChange={(e) =>
									setNewPS((prev) => ({ ...prev, city: e.target.value }))
								}
							/>
						</div>

						{/* coordinates */}
						<div
							className={`${containerStyles} cursor-pointer bg-bg hover:opacity-70`}
							onClick={() => setShowMap(true)}
						>
							<div className={iconStyles}>
								<BiMap />
							</div>
							<p className="text-sm text-dark flex items-center">
								{newPS.longitude
									? newPS.longitude + " - " + newPS.latitude
									: "Get Coordinates"}
							</p>
						</div>
					</div>

					{/* Parking Information */}
					<div className={mainContainerStyles}>
						{/* divider */}
						<div className="w-full my-5">
							<h1 className="w-fit px-4 border-b mx-auto text-darker uppercase">
								Parking Information
							</h1>
						</div>

						{/* total */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<CgList />
							</div>
							<input
								type="number"
								className={inputStyles}
								placeholder="Total Slots"
								value={newPS.totalSlots}
								onChange={(e) =>
									setNewPS((prev) => ({ ...prev, totalSlots: e.target.value }))
								}
							/>
						</div>

						{/* shaded */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<AiOutlineNumber />
							</div>
							<input
								type="number"
								className={inputStyles}
								placeholder="Shaded Slots"
								value={newPS.shadedSlots}
								onChange={(e) =>
									setNewPS((prev) => ({ ...prev, shadedSlots: e.target.value }))
								}
							/>
						</div>

						{/* paid */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<RiMoneyDollarCircleLine />
							</div>
							<input
								type="number"
								className={inputStyles}
								placeholder="Paid Slots"
								value={newPS.paidSlots}
								onChange={(e) =>
									setNewPS((prev) => ({ ...prev, paidSlots: e.target.value }))
								}
							/>
						</div>
					</div>

					{/* Timings Information */}
					<div className={mainContainerStyles}>
						{/* divider */}
						<div className="w-full my-5">
							<h1 className="w-fit px-4 border-b mx-auto text-darker uppercase">
								Timings Information
							</h1>
						</div>

						{/* from */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<BsClockHistory />
							</div>

							<h1 className="text-sm  uppercase flex items-center mr-2">
								From:
							</h1>

							<input
								type="time"
								className={inputStyles}
								value={newPS.from}
								onChange={(e) =>
									setNewPS((prev) => ({ ...prev, from: e.target.value }))
								}
							/>
						</div>

						{/* to */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<TbClockOff />
							</div>

							<h1 className="text-sm  uppercase flex items-center mr-2">To:</h1>

							<input
								type="time"
								className={inputStyles}
								value={newPS.to}
								onChange={(e) =>
									setNewPS((prev) => ({ ...prev, to: e.target.value }))
								}
							/>
						</div>
					</div>

					{/* Week Information */}
					<div className={mainContainerStyles}>
						{/* divider */}
						<div className="w-full my-5">
							<h1 className="w-fit px-4 border-b mx-auto text-darker uppercase">
								Availability Information
							</h1>
						</div>

						{/* days */}
						<div className={containerStyles}>
							<div className={iconStyles}>
								<MdOutlinePlaylistAddCheck />
							</div>

							{/* monday */}
							<button
								className={`
                                px-2 mx-1 
                                border rounded-md
                                ${
																	newPS.mon === true
																		? "text-green-400 border-green-400"
																		: ""
																}
                                `}
								onClick={() =>
									setNewPS((prev) => ({
										...prev,
										mon: newPS.mon === true ? false : true,
									}))
								}
							>
								Mon
							</button>

							{/* tuesday */}
							<button
								className={`
                                px-2 mx-1 
                                border rounded-md
                                ${
																	newPS.tue === true
																		? "text-green-400 border-green-400"
																		: ""
																}
                                `}
								onClick={() =>
									setNewPS((prev) => ({
										...prev,
										tue: newPS.tue === true ? false : true,
									}))
								}
							>
								Tue
							</button>

							{/* wednesday */}
							<button
								className={`
                                px-2 mx-1 
                                border rounded-md
                                ${
																	newPS.wed === true
																		? "text-green-400 border-green-400"
																		: ""
																}
                                `}
								onClick={() =>
									setNewPS((prev) => ({
										...prev,
										wed: newPS.wed === true ? false : true,
									}))
								}
							>
								Wed
							</button>

							{/* thursday */}
							<button
								className={`
                                px-2 mx-1 
                                border rounded-md
                                ${
																	newPS.thu === true
																		? "text-green-400 border-green-400"
																		: ""
																}
                                `}
								onClick={() =>
									setNewPS((prev) => ({
										...prev,
										thu: newPS.thu === true ? false : true,
									}))
								}
							>
								Thu
							</button>

							{/* friday */}
							<button
								className={`
                                px-2 mx-1 
                                border rounded-md
                                ${
																	newPS.fri === true
																		? "text-green-400 border-green-400"
																		: ""
																}
                                `}
								onClick={() =>
									setNewPS((prev) => ({
										...prev,
										fri: newPS.fri === true ? false : true,
									}))
								}
							>
								Fri
							</button>

							{/* saturday */}
							<button
								className={`
                                px-2 mx-1 
                                border rounded-md
                                ${
																	newPS.sat === true
																		? "text-green-400 border-green-400"
																		: ""
																}
                                `}
								onClick={() =>
									setNewPS((prev) => ({
										...prev,
										sat: newPS.sat === true ? false : true,
									}))
								}
							>
								Sat
							</button>

							{/* sunday */}
							<button
								className={`
                                px-2 mx-1 
                                border rounded-md
                                ${
																	newPS.sun === true
																		? "text-green-400 border-green-400"
																		: ""
																}
                                `}
								onClick={() =>
									setNewPS((prev) => ({
										...prev,
										sun: newPS.sun === true ? false : true,
									}))
								}
							>
								Sun
							</button>
						</div>
					</div>

					{/* Images */}
					<div className={mainContainerStyles}>
						{/* divider */}
						<div className="w-full my-5">
							<h1 className="w-fit px-4 border-b mx-auto text-darker uppercase">
								Images
							</h1>
						</div>

						<div className={"flex flex-1 justify-center"}>
							{/* image 1 */}
							<div className={imageStyles}>
								{newPS.img1 ? (
									<img src={newPS.img1} alt="parking_space_image" />
								) : (
									<RiImageAddLine size={100} className="m-auto text-gray-100" />
								)}

								<input
									type="file"
									className="absolute top-0 left-0 h-full w-full opacity-0 cursor-pointer"
									onClick={(e) => {
										if (!validate(e)) {
											console.log(e.target.value);
											e.target.value = null;
											setNewPS((prev) => ({ ...prev, img1: null }));
											return;
										}

										const reader = new FileReader();
										reader.onload = (e) => {
											// set images
											if (reader.readyState === 2) {
												setNewPS((prev) => ({ ...prev, img1: reader.result }));
											}
										};
										reader.readAsDataURL(e.target.files[0]);
									}}
								/>
							</div>

							{/* image 2 */}
							<div className={imageStyles}>
								{newPS.img2 ? (
									<img src={newPS.img2} alt="parking_space_image" />
								) : (
									<RiImageAddLine size={100} className="m-auto text-gray-100" />
								)}

								<input
									type="file"
									className="absolute top-0 left-0 h-full w-full opacity-0 cursor-pointer"
									onClick={(e) => {
										if (!validate(e)) {
											console.log(e.target.value);
											e.target.value = null;
											setNewPS((prev) => ({ ...prev, img2: null }));
											return;
										}

										const reader = new FileReader();
										reader.onload = (e) => {
											// set images
											if (reader.readyState === 2) {
												setNewPS((prev) => ({ ...prev, img2: reader.result }));
											}
										};
										reader.readAsDataURL(e.target.files[0]);
									}}
								/>
							</div>

							{/* image 3 */}
							<div className={imageStyles}>
								{newPS.img3 ? (
									<img src={newPS.img3} alt="parking_space_image" />
								) : (
									<RiImageAddLine size={100} className="m-auto text-gray-100" />
								)}

								<input
									type="file"
									className="absolute top-0 left-0 h-full w-full opacity-0 cursor-pointer"
									onClick={(e) => {
										if (!validate(e)) {
											console.log(e.target.value);
											e.target.value = null;
											setNewPS((prev) => ({ ...prev, img3: null }));
											return;
										}

										const reader = new FileReader();
										reader.onload = (e) => {
											// set images
											if (reader.readyState === 2) {
												setNewPS((prev) => ({ ...prev, img3: reader.result }));
											}
										};
										reader.readAsDataURL(e.target.files[0]);
									}}
								/>
							</div>
						</div>
					</div>

					{/* Create Button */}
					<div className={mainContainerStyles}>
						<button
							className="bg-main text-white m-4 mt-12 px-8 py-1 rounded-md hover:opacity-70"
							onClick={() => handleCreate()}
						>
							Create
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
